<template>
  <div>
    <b-row>
      <b-col v-loading="loading" class="col-12 col-lg-4 mt-4">
        <stats-card title="Valor em débito" type="success" class="mb-0" :sub-title="valueTotalUnpaidBills"
          v-bind:icon="!this.isMobile ? 'fas fa-dollar-sign' : ''">
        </stats-card>
      </b-col>

      <b-col v-loading="loading" class="col-12 col-lg-4 mt-4">
        <stats-card title="Tempo de débito" type="primary" class="mb-0" :sub-title="firstUnpaidBill"
          v-bind:icon="!this.isMobile ? 'fas fa-clock' : ''">
        </stats-card>
      </b-col>

      <b-col v-loading="loading" class="col-12 col-lg-4 mt-4">
        <stats-card title="Compras pendentes" type="danger" :sub-title="unpaidBills"
          v-bind:icon="!this.isMobile ? 'fas fa-arrow-down' : ''">
        </stats-card>
      </b-col>
    </b-row>

    <b-card>
      <template>
        <!-- Subtitle -->
        <h5 class="surtitle mb-2">Histórico de compras</h5>
        <!-- Title -->
        <!-- <h5 class="h3 mb-0">Últimas compras</h5> -->
        <line-chart :height="200" v-if="this.bills.view && this.bills.view.paidBillsProducts.length"
          :chart-data="salesChart.chartData">
        </line-chart>
      </template>
    </b-card>

    <b-row align-v="center">
      <b-col cols="8">
        <h3 class="mb-0">Dados do cliente</h3>
      </b-col>
    </b-row>

    <b-form>
      <base-input type="text" label="Nome" v-model="form.name"></base-input>
      <base-input type="text" label="Documento" :required="true" v-model="form.cpf" maxlength="18"
        v-mask="getDocMask(form.cpf)" @keyup="form.cpf = String(form.cpf || '').toUpperCase()"></base-input>
      <base-input v-for="field in fields" :key="field.id" :name="field.label" :type="typeField(field.type)"
        :label="field.label" v-model="field.value">
        <select class="form-control" v-model="field.value" v-if="field.type == 'select' && field.label == 'Categoria'">
          <option v-for="category in Object.keys(field.options)" :key="category" :label="category" :value="category">
          </option>
        </select>
        <select class="form-control" v-model="field.value" v-if="field.type == 'select' && field.label == 'País'">
          <option @click="setUF(country.id)" v-for="country in countries" :key="country.id" :label="country.name"
            :value="country.name"></option>
        </select>
        <select class="form-control" v-model="field.value" v-if="field.type == 'select' && field.label == 'UF'">
          <option @click="setCities(state.id)" v-for="state in states" :key="state.id" :label="state.name"
            :value="state.uf"></option>
        </select>
        <select class="form-control" v-model="field.value" v-if="field.type == 'select' && field.label == 'Cidade'">
          <option v-for="city in cities" :key="city.id" :label="city.name" :value="city.name"></option>
        </select>
      </base-input>
      <!-- inicio form global 
       montar o formulário dinâmico de acordo com os XFields passados (clients, agents, users...)
      -->

      <!-- fim form global -->
    </b-form>
    <button @click.prevent="saveClient()">Editar</button>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from "vuex";
import moment from "moment";
import axios from "axios";
import swal from "sweetalert2";
import LineChart from '@/components/Charts/LineChart';
import * as chartConfigs from "@/components/Charts/config";
import { Charts } from "@/components/Charts/config";
import cakeService from '@/services/cakephp'
import store from '@/store'
import { VueMaskDirective } from 'v-mask'
export const cakeBaseURL = process.env.VUE_APP_API_CAKE_URL; // cake api
export default {
  components: {
    LineChart
  },
  directives: { mask: VueMaskDirective },
  props: {
    client: {
      type: Object,
    },
    isMobile: {
      type: Boolean
    }
  },
  data() {
    return {
      fields: [],
      countries: [],
      states: [],
      cities: [],
      form: {
        name: '',
        cpf: ''
      },
      loading: false,
      bills: {},
      paidBills: {},
      unpaidBills: "",
      valueTotalUnpaidBills: "",
      firstUnpaidBill: "",
      xFieldsMap: {},
      totalValue: 0,
      billscount: 0,
      salesChart: {
        chartData: {
          labels: [],
          datasets: [
            {
              label: "Valor comprado",
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
      extraOptions: {
        scales: {
          yAxes: [{
            gridLines: {
              color: Charts.colors.gray[200],
              zeroLineColor: Charts.colors.gray[200]
            }
          }]
        }
      }
    };
  },
  computed: {
    clientXFields() {
      return store.state.auth.params.ClientXFields;
    },
  },
  watch: {
    bills() {
      if (this.bills.view.unpaidBillsProducts.length > 0) {
        //valor total das contas
        this.billscount = {}
        this.bills.view.unpaidBillsProducts.map((bill) => {
          this.billscount[bill.Bills.id] = 1
          this.totalValue += parseFloat(bill.BillsProduct.price * bill.BillsProduct.amount);
        })
        this.billscount = Object.keys(this.billscount).length
        //total em itens e de contas pendentes
        this.unpaidBills = `${this.bills.view.unpaidBillsProducts.length.toString()} itens em ${this.billscount} contas`

        this.valueTotalUnpaidBills = `R$ ${this.totalValue
          .toFixed(2)
          .toString()
          .replace(".", ",")}`;
        const [data, hora] =
          this.bills.view.unpaidBillsProducts[
            this.bills.view.unpaidBillsProducts.length - 1
          ].BillsProduct.date.split(" ");
        const [ano, mes, dia] = data.split("-");
        var a = moment();
        var b = moment([ano, mes - 1, dia])
        //tempo em meses de débito
        this.firstUnpaidBill = `${a.diff(b, "days").toString()} Dias`;
      } else {
        (this.unpaidBills = "0"),
          (this.valueTotalUnpaidBills = "R$ 0,00"),
          (this.firstUnpaidBill = "-");
      }
      this.loadChartData()
    },
  },
  methods: {
    ...mapActions("client", ["getBillsClient"]),
    getDocMask(value) {
      const doc = String(value || '')
      if (/[A-Za-z]/.test(doc)) return 'AA######'
      const digits = doc.replace(/\D/g, '')
      if (digits.length > 11) return '##.###.###/####-##'
      return '###.###.###-##'
    },
    typeField(type) {
      if (type == 'mail') return 'email'
      if (type == 'text') return 'text'
      if (type == 'select') return 'select'
      if (type == 'phone') return 'tel'
      if (type == 'textarea') return 'textarea'
    },
    async loadBills() {
      this.loading = true;
      const bills = await this.getBillsClient(this.client);
      this.bills = bills;
      this.loading = false;
    },
    async loadClientXfieldsMap() {
      // TODO: mudar para  const data  = await cakeApi.getFieldsMap('clients')
      // import cakeApi from '@/services/cakephp'

      const { data } = await axios.get(
        `${cakeBaseURL}clients/json/map`
      )
      this.xFieldsMap = Object.entries(data.map)
    },
    last12Mounths(now = moment()) {
      let months = []
      for (let i = 1; i <= 12; i++) {
        const month = moment(now).format('MMM')
        months.push(month)
        now = moment().subtract(i, 'M')
      }
      return months
    },
    loadChartData() {
      //loading last12Mounths data
      const daysAgo = moment().subtract(365, 'days').valueOf()
      this.bills.view.paidBillsProducts.map(paidItem => {
        if (moment(paidItem.BillsProduct.date).valueOf() >= daysAgo) {
          var month = moment(paidItem.BillsProduct.date).get('month')
          if (this.salesChart.chartData.datasets[0].data[month] != undefined) {
            this.salesChart.chartData.datasets[0].data[month] += paidItem.BillsProduct.amount * paidItem.BillsProduct.price
          }
          else {
            this.salesChart.chartData.datasets[0].data[month] = 0
          }
        }
      })
    },
    setFields() {
      const arr1 = Object.entries(this.client).map(function (key) {
        return {
          key: key[0],
          value: key[1]
        }
      })
      const arr2 = Object.entries(this.clientXFields).map(function (key) {
        let field = arr1.find(element => element.key == key[0])
        if (field != undefined) {
          if (field.key == 'País') {
            return {
              ...key[1],
              value: field.value,
              options: [field.value]
            }
          }
          return { ...key[1], value: field.value }
        }
        return { ...key[1], value: '' }
      })

      if(arr2.length == 0){
        arr2 = [{label:'País',type: 'select',value:'Brasil'},{label:'UF',value:'Ba'}]
      }

      this.fields = arr2
    },
    async setCountries() {
      await cakeService.getCountries().then((result)=>{
        this.countries = Object.entries(JSON.parse(result.countries)).map(country => {
          return {
            id: country[0],
            name: country[1]
          }
        })
        this.setFields()
        this.localLocation()
      })
    },
    async setUF(countryId) {
      await cakeService.getUF(countryId).then((response)=>{
        this.states = JSON.parse(response.states).map(state => {
          return {
            id: state[0],
            uf: state[1],
            name: state[2]
          }
        })
      })

    },
    async setCities(stateId) {
      const { cities } = await cakeService.getCities(stateId)
      this.cities = Object.entries(JSON.parse(cities)).map(city => {
        return {
          id: city[0],
          name: city[1]
        }
      })
    },
    localLocation() {      
      const { value } = this.fields.find(field => field.label == 'País')
      const { id } = this.countries.find != undefined ? this.countries.find(country => country.name == value):{id:1,name:'Brasil'}
      const field = this.fields.length?this.fields.find(field => field.label == 'UF'):{value:'Ba'}
      const state = this.states.length?this.states.find(state => state.uf == field.value):{id: 5,name:'Ba'}
      // console.log('value',value)
      // console.log('id',id)
      // console.log('field',field)
      // console.log('state',state)
      // console.log('this.fields.length',this.fields,this.states.length,this.states,state)
      this.setUF(id)
      // this.setCities(state.id)
    },
    async saveClient() {
      let clientData = JSON.parse(JSON.stringify(this.fields))
      const countries = this.countries
      const states = this.states
      let countryName = ''
      let stateName = ''
      clientData.forEach((element, idx) => {
        if (element.label == 'País') {
          countryName = element.value

          element.value = countries.find(country => country.name == countryName)['id']

        } else if (element.label == 'UF') {
          stateName = element.value
          element.value = states.find(state => state.uf == stateName)['id']

        }
      })

      let response = await cakeService.saveClient({
        ...this.form,
        dataXFields: clientData,
        xfields: this.clientXFields
      })
      response = JSON.parse(response)
      response.flash = JSON.parse(response.flash)

      swal.fire({
        // title: response.flash.title || false,
        // text: response.flash.message || 'tente novamente',
        title: response.flash.message || 'Esta ação falhou',
        buttonsStyling: false,
        confirmButtonClass: `btn btn-${response.flash.params.class || 'danger '}`,
        icon: response.status || 'error',
      })

      if (response.status == 'success') {
        //TODO: fechar modal....
        //TODO: atualizar dados da tabela com os novos valores: response.Client
      }

    }
  },
  async created() {
    await this.setCountries()    
    this.form = {
      ...this.client,
      name: this.client.name,
      cpf: this.client.cpf,
    }
    this.salesChart.chartData.labels = this.last12Mounths().reverse()
  },
  async mounted() {
    await this.loadBills();
    this.loadClientXfieldsMap();
  },
};
</script>

<style></style>
